import { List as MantineList } from "@mantine/core";

export const List = MantineList;
